import React from "react";
import { Button, Skeleton } from "antd";
import { Link } from 'react-router-dom'
import SImage from "../SImage";

const CategoryItem = ({ data, onClick }) => {
  return (
    <Link
      to={`/category?cateId=${data.id}`}
      onClick={onClick}
    >
      <div className="m-1 mr-[24px] sm:h-[80px] h-[46px] w-full bg-[#FFFFFF] sm:rounded-2xl rounded-[10px] overflow-hidden hover:shadow-lg flex shadow">

        <SImage className="object-cover sm:w-[75px] w-[46px]" src={data.icon} alt=""  onerror="this.onerror=null;this.src='https://www.steaua-dunarii.ro/client/img/image-not-found.png'"/>

        {data.name ? (
          <div className="items-center flex flex-1 p-2 sm:p-4  h-[full]  rounded-r-2xl ">
            <p
              className="sm:text-sm text-[10px] text-two-lines font-semibold leading-5 tracking-wide capitalize"
            >
              {data.name}
            </p>
          </div>
        ) : (
          <Skeleton active size="small" className="m-3" />
        )}
      </div>
    </Link>
  );
};

export default CategoryItem;
